<fr-isc-form
  Id="config-settings"
  [ngClass]="mode === 'view' ? 'review-step' : null"
  [FDN]="FDN"
  [formModel]="formModel"
  [mode]="mode"
  [buttons]="mode === 'edit' ? buttons : null"
>
</fr-isc-form>
